import { Table } from 'antd'
import { ProposedTenant } from '../../../models'
import { buildIssuersTableColumns } from './issuers-table-columns'

interface Props {
  tenant: ProposedTenant
}

export const IssuersPanel = ({ tenant }: Props) => {
  return (
    <Table
      columns={buildIssuersTableColumns()}
      dataSource={tenant?.issuers}
      loading={!tenant}
      rowKey="id"
      pagination={false}
      size="small"
    />
  )
}
